import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { SelectFromAssetPage } from './select-from-asset.page';

const routes: Routes = [
  {
    path: '',
    component: SelectFromAssetPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [SelectFromAssetPage]
})
export class SelectFromAssetPageModule {}
